
//Représente les données des paramètres d’un client
export class DonneesParametresClient 
{
  //Création
  constructor () 
  {
    this.code = "";
    this.identifiant = "";
    this.urlApi = "";
    this.urlBackOffice = "";
  }

  //Code
  public code: string;

  //Identifiant
  public identifiant: string;

  //Url de l’API
  public urlApi: string;

  //Url du back office
  public urlBackOffice: string;

  //Login de l’utilisateur
  public loginUtilisateur!: string;
}

export const parametresClient: DonneesParametresClient = new DonneesParametresClient ();
